/*
 * NProgress
 * */

import NProgress from 'nprogress'; // Progress 进度条
import Reqs from '@/services/api/layout/layout';
import 'nprogress/nprogress.css'; // Progress 进度条 样式
import {
  validatenull
} from '@/utils/validate';
import tags from '@/store/tags/tags'
import router from '../index'
import Vue from 'vue';
import store from '@/store';
import {
  diff,
  Storage,
  Cookie
} from '@/utils/utils';
import website from '@/const/website';
import home from '@/router/routes/home'
import exception from '@/router/routes/exception'
import admin from '@/router/routes/admin'
let stateLayout = store.state["layout/layout"];
const isFirstPage = website.isFirstPage;
const tagWel = website.fistPage;
let ADD_TAG = (state, action) => { // 添加标签
  state.tag = action;
  Storage.setSession('tag', state.tag);
  let flg = state.tagList.findIndex(ele => diff(ele, action))
  console.log(flg, state.tagList.length - 2, state.tagList.length, state.tagList, flg === state.tagList.length - 2)
  if (flg > -1 && flg === state.tagList.length - 2) {
    // 判断是否是回退
    state.tagList.splice(-1)
    setFistTag(state.tagList)
    Storage.setSession('tagList', state.tagList)
    return
  }
  if (flg !== -1) {
    state.tagList.splice(flg, 1)
  }
  state.tagList.push(action);
  setFistTag(state.tagList);
  Storage.setSession('tagList', state.tagList);
}
let setFistTag = (list) => { // 判断是否第一个路由
  if (list.length == 1) {
    list[0].close = false;
  } else {
    list.forEach((ele) => {
      if (ele.value === tagWel.value && isFirstPage === false) {
        ele.close = false;
      } else {
        ele.close = true;
      }
    });
  }
}
let defaultActive = ''
let getMenu = () => { // 获取菜单栏
  return new Promise((resolve, reject) => {
    Reqs.getMenu({}).then(res => {
      stateLayout.roleMenuList = JSON.parse(JSON.stringify(res.menusTree))
      defaultActive = res.setMenu ? res.setMenu.defaultActive : ''
      stateLayout.userInfo = {
        username: res.userName
      }
      resolve()
    }).catch(err => {
      reject(err)
    })
  })
}
let setRouter = (res) => { // 处理返回的数据
  let pathArr = res.menuUrl.split('/')
  let name = res.menuUrl ? pathArr[pathArr.length - 1] : ''
  let path = res.menuUrl
  let title = res.menuName
  return {
    name: res.menuUrl,
    path: path,
    meta: {
      title: title,
      name: title,
      // auth: true,
      menu: path,
      href: path,
      icon: 'icon',
      isTab: true,
      // redirect: 'noredirect',
    },
    component: () => import( /* webpackChunkName: 'warehouse-space' */
      `@/views${path}`),
  }
}
let getRouter = () => { // 过滤添加路由
  let copyRoutes = JSON.parse(JSON.stringify(stateLayout.roleMenuList))
  let arrRouter = [{
    name: 'app', // 路由 name
    path: '/',
    meta: {
      title: '首页',
      name: '首页',
      href: '',
      isTab: false
    },
    component: () => import('@/layouts/app'),
    children: [],
  }]
  let itemRouter = []
  const checkList = (res) => {
    for (let i = 0; i < res.length; i++) {
      if (res[i].parentId * 1 > 0 && res[i].menuUrl) {
        itemRouter.push(setRouter(res[i]))
      }
      if (res[i].children) {
        checkList(res[i].children);
      }
    }
  };
  checkList(copyRoutes);
  arrRouter[0].children.push(...itemRouter)
  arrRouter[0].children.push(...home, ...admin, ...exception) // 非权限路由，手动添加
  router.addRoutes(arrRouter)
}
let setRoutes = (to, from, next) => { // 设置路由表
  return new Promise((resolve, reject) => {
    let routes = JSON.parse(JSON.stringify(stateLayout.roleMenuList))
    let tag = Storage.getSession('tag')
    if ((!routes || !routes.length) || from.path === '/login') {
      getMenu().then(() => {
        getRouter()
        resolve()
        if (!!tag) {
          next({
            path: tag.value
          })
        } else if (!defaultActive) {
          // next({
          //   path: stateLayout.roleMenuList[0].children[0].menuUrl
          // })
          next()
        } else {
          next({
            path: defaultActive
          })
        }

      }).catch(err => {
        reject()
      })
    }
    resolve()
  })

}
let wit = ['/restPasswork']
export default {
  start: async (to, from, next) => {
    let ele = document.getElementsByClassName('el-card')[0]
    if (from.meta.keepAlive == true && ele) { // 缓存滚动条
      // stateLayout.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      stateLayout.scrollTop = ele.scrollTop
    }
    NProgress.start(); // 开启Progress
    stateLayout.isRouterShowView = false
    const meta = to.meta || {};
    if (wit.indexOf(to.path) > -1) {
      next()
    } else if (stateLayout.isLock && to.path != '/lock') { //如果系统激活锁屏，全部跳转到锁屏页
      next({
        path: '/lock'
      })
      NProgress.done();
    } else if (to.path === '/login') {
      if (!Storage.get('wfUserInfo')) {
        next()
      } else {
        next({
          path: from.path
        })
      }
      NProgress.done();
    } else {
      if (!Storage.get('wfUserInfo')) {
        next({
          path: '/login'
        })
        NProgress.done();
        return
      }
      // await setRoutes(to, from, next) // 获取路由
      // setUserInfo() // 设置用户信息
      const value = to.query.src || to.fullPath;
      const label = to.meta.title || to.title;
      if (meta.isTab !== false && !validatenull(value) && !validatenull(label)) {
        ADD_TAG(store.state['tags/tags'], {
          label,
          value,
          params: to.params,
          query: to.query,
          group: router.$avueRouter || [],
        })
      }
      next();
    }
  },
  done: (to, from, next) => {
    stateLayout.isRouterShowView = true
    NProgress.done(); // 结束Progress
    // 如果进入后的页面不想需要缓存，则设置scrollTop = 0
    let ele = document.getElementsByClassName('el-card')[0]
    if (!to.meta.keepAlive && ele) {
      console.log("不需要缓存");
      setTimeout(() => {
        // document.documentElement.scrollTop = 0;
        // document.body.scrollTop = 0; // document.body.scrollTop一定要加不然iOS上会失效，本人亲测，踩坑
        ele.scrollTop = 0
      }, 10)
    } else if (ele) {
      console.log("需要缓存" + stateLayout.scrollTop);
      setTimeout(() => {
        // document.documentElement.scrollTop = stateLayout.scrollTop;
        // document.body.scrollTop = stateLayout.scrollTop;
        ele.scrollTop = stateLayout.scrollTop
      }, 50)
    }
  },
};
